<template>
  <div class="icon-cart">

    <b-spinner label="Loading..." class="spin" v-if="loading"/>

    <svg :width="width" :height="height" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.951172" y="0.015625" width="55" height="55" rx="100%" :fill="iconBackground"/>
      <g v-if="!loading">

        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M26.6815 37.6133C26.6815 38.7862 25.7306 39.7372 24.5575 39.7372C23.3845 39.7372 22.4336 38.7862 22.4336 37.6133C22.4336 36.4401 23.3845 35.4893 24.5575 35.4893C25.7306 35.4893 26.6815 36.4402 26.6815 37.6133Z"
              fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M36.201 37.6133C36.201 38.7862 35.2501 39.7372 34.077 39.7372C32.9041 39.7372 31.9531 38.7862 31.9531 37.6133C31.9531 36.4401 32.9041 35.4893 34.077 35.4893C35.2502 35.4893 36.201 36.4402 36.201 37.6133Z"
              fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M29.2813 27.072C28.746 27.072 28.2938 26.6197 28.2938 26.0844V23.4619H25.6713C25.1268 23.4619 24.6837 23.019 24.6836 22.4745C24.6836 21.9392 25.1358 21.4869 25.6712 21.4869H28.2936V18.8645C28.2936 18.3292 28.7459 17.877 29.2811 17.877C29.8165 17.877 30.2687 18.3292 30.2687 18.8645V21.4869L32.8913 21.4868C33.4266 21.4868 33.8789 21.9391 33.8789 22.4744C33.8789 23.0097 33.4266 23.4619 32.8913 23.4619H30.2689V26.0844C30.2689 26.6197 29.8167 27.072 29.2813 27.072Z"
              fill="white" v-if="!isRemove"/>
        <mask id="mask0_1039_5808" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="13" y="17" width="27"
              height="17">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8594 17.3301H39.9865V33.7859H13.8594V17.3301Z"
                fill="white"/>
        </mask>
        <g mask="url(#mask0_1039_5808)">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M24.7001 33.7859C22.5995 33.7859 20.7416 32.2763 20.2825 30.1965L18.0137 19.5053H14.9469C14.3574 19.5053 13.8594 19.0073 13.8594 18.4177C13.8594 17.8282 14.3574 17.3301 14.9469 17.3301H18.9153C19.4307 17.3301 19.8586 17.6733 19.9802 18.184L22.4385 29.7214C22.6508 30.7823 23.6353 31.5828 24.7282 31.5828L33.7829 31.5826C34.8881 31.5826 35.8294 30.8414 36.072 29.7799L37.888 22.068C37.9866 21.5759 38.412 21.2336 38.9227 21.2336C39.0107 21.2336 39.0994 21.2442 39.1862 21.265C39.4702 21.336 39.7155 21.5242 39.8585 21.7813C39.9954 22.027 40.0236 22.3097 39.9379 22.5772L39.9362 22.5824L38.1173 30.3055C37.8809 31.3171 37.3336 32.1863 36.5348 32.8192C35.7364 33.4516 34.7654 33.7859 33.7268 33.7859H24.7001Z"
                fill="white"/>
        </g>
        <rect x="25.0293" y="21.6123" width="8.59375" height="1.71875" rx="0.859375" fill="white" v-if="isRemove"/>
      </g>
    </svg>
  </div>
</template>

<script>
export const ADD_TO_CART = 'add'
export const REMOVE_TO_CART = 'remove'
export default {
  name: "IconCart",

  props: {
    width: {
      default: 56,
      required: false,
      type: Number
    },
    height: {
      default: 56,
      required: false,
      type: Number
    },
    rx: {
      default: 27.5,
      required: false,
      type: Number
    },
    action: {
      default: ADD_TO_CART,
      required: false,
      type: String
    },
    loading: {
      default: false,
      required: false,
      type: Boolean
    }
  },
  computed: {
    iconBackground() {
      return this.isAdd && !this.loading ? 'var(--primary)' : '#808080'
    },
    isAdd() {
      return this.action === ADD_TO_CART && !this.loading
    },
    isRemove() {
      return this.action === REMOVE_TO_CART && !this.loading
    }
  }
}
</script>
